import { render, staticRenderFns } from "./CustomerAdminForm.vue?vue&type=template&id=fde0d2c2&"
import script from "./CustomerAdminForm.vue?vue&type=script&lang=ts&"
export * from "./CustomerAdminForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports